import React from 'react';
import EylulGerceklesen from './EylulGerceklesen';

/**
 * HUPALUPA Eğlence — Eylül 2026 medya planı (tam plan, kampanya kırılımlı).
 * Kardeş sayfalar: KixxEylul2026MedyaPlani, KerametIlicasiEylul2026MedyaPlani.
 * Üçü de aynı iskelet: odak → arama talebi → ön koşul → mecra tablosu →
 * amaç dağılımı → bütçe kartları → kampanya tablosu → uygulama notları.
 *
 * 🔑 Bütçe Efe'nin kararı: ₺300.000 (slayt sürümü ₺250.000 öneriyordu).
 * Ağustos kapanışı ₺289.724 olduğu için ay pratikte SABİT kalıyor.
 *
 * 🔑 1 Eylül revizyonu (Efe): Meta'dan Google'a kaydırma.
 *  a) Jenerik arama ₺20.000 → ₺60.000, para Meta DM kampanyalarından alındı
 *     (Atölyeleri 60→33, DoğumGünü 25→12).
 *  c) Etkileşim kitlesine giden DM kampanyası KAPATILDI (Efe), ₺10.000'i
 *     doğum günü kampanyasına geçti → DoğumGünü ₺22.000. Mesaj tarafı iki
 *     kampanyaya indi, toplamı ₺55.000'de sabit kaldı.
 *  b) Etkileşimden ₺25.000 alınıp AYRI bir awareness kampanyası açıldı.
 *     Gerekçe veri: Temmuz'daki OUTCOME_AWARENESS carousel CPM ₺7,45,
 *     Engagement kampanyası CPM ₺43,9 → erişim ~5,9× ucuz.
 * Sonuç: Meta ₺185.000 → ₺145.000, Google ₺95.000 → ₺135.000.
 *
 * 🔴🔴 Jenerik 4,4× büyüyor ama Ağustos'ta 4.979 tıka 12,6 dönüşüm verdi
 * (CPC yalnızca ₺2,74 — ucuz ama niyetsiz trafik). Bütçe ancak kelime listesi
 * daraltılıp eşleme tipi sıkılaştırılırsa serbest bırakılmalı.
 *
 * 🔴🔴 Kategori talebi Eylül'de düşüyor (sepet −%26 / −%27, iki yıl da).
 * Bütçe sabit kalıyorsa gerekçe hacim değil KARMA olmak zorunda: düşmeyen
 * segmentler (atölye, doğum günü, oyun alanı) öne alınıyor.
 * 🔑🔑 `çocuk atölyesi` Temmuz 2026'da 2.900, Temmuz 2025'te 1.000 → 2,9× YoY.
 * Hesap zaten Ağustos'ta atölyeye ₺61.562 harcamış; plan bunu resmileştiriyor.
 *
 * Ağustos rakamları 1 Eylül 2026'da, ay kapandıktan sonra çekildi:
 *  · Meta   → Graph API act_1492081179012995, kampanya seviyesi insights.
 *  · Google → fetch_google_ads_campaign_insights_live.py, müşteri 6717327296.
 *  · TikTok → business-api /report/integrated/get/, advertiser 7604848080818683921.
 * 🔴 TikTok hesabı Store ile ORTAK: Ağustos'taki ₺4.938'lik
 * `Glowy_HupalupaStore_TikTok Traffic` bu markanın harcamasında görünüyor.
 * 🔴 TikTok'un `clicks` metriği `engagements` ile birebir aynı geliyor
 * (Ağustos: 190.255 / 190.255) → TikTok tıklaması RAPORLANMAZ.
 *
 * Arama hacimleri: Keyword Planner, GenerateKeywordHistoricalMetrics,
 * geo İstanbul (21069), dil TR (1000), network GOOGLE_SEARCH, çekim 1 Eyl 2026.
 */

/* Gerçekleşen bölümünün plana bakacağı mecra bütçeleri; aşağıdaki plan
   tablosuyla AYNI rakamlar (Google 135.000 + Meta 145.000 + TikTok 20.000). Tabloyu değiştirirsen burayı da değiştir. */
export const BRAND_ID = '9e3c368d-d70d-4ba4-9506-fa0f65b526f7';
export const MECRA_PLANI = { GOOGLE_ADS: 135000, META_ADS: 145000, TIKTOK_ADS: 20000 };

const AMAC_STIL = {
  'Farkındalık': 'bg-red-50 text-red-700 border-red-200',
  'Etkileşim': 'bg-pink-50 text-pink-700 border-pink-200',
  'Trafik': 'bg-sky-50 text-sky-700 border-sky-200',
  'Dönüşüm': 'bg-emerald-50 text-emerald-700 border-emerald-200',
};

function Amac({ tip, not }) {
  return (
    <span className={`inline-flex items-center px-2 py-0.5 rounded-md border text-[11px] font-medium whitespace-nowrap ${AMAC_STIL[tip] || 'bg-gray-50 text-gray-700 border-gray-200'}`}>
      {tip}{not ? ` (${not})` : ''}
    </span>
  );
}

export default function HupalupaEglenceEylul2026MedyaPlani() {
  return (
    <div className="p-6 max-w-7xl mx-auto space-y-16">

      <div className="bg-white rounded-2xl shadow-sm border overflow-hidden">
        <div className="bg-white border-b p-5 flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
          <div className="flex items-center gap-4">
            <div className="rounded-lg bg-white border border-gray-200 px-3 py-2">
              <img src="/logos/grup/hupalupa-eglence.png" alt="HUPALUPA Eğlence" className="h-7 w-auto object-contain" />
            </div>
            <div className="ml-1">
              <h2 className="text-lg font-bold text-gray-800">HUPALUPA Eğlence Eylül 2026 Medya Planı</h2>
              <p className="text-sm text-gray-500">Eğlence merkezi · atölye ve doğum günü rezervasyonu · Meta (Etkileşim + DM) · Google (Arama + YouTube) · TikTok</p>
            </div>
          </div>
          <div className="flex items-center gap-3">
            <span className="inline-flex items-center px-3 py-1 bg-gray-100 text-gray-600 text-xs font-medium rounded-full border border-gray-200">
              1 - 30 Eylül 2026
            </span>
            <span className="inline-flex items-center px-3 py-1.5 bg-gray-800 text-white text-sm font-semibold rounded-full">
              Toplam: ₺300.000
            </span>
          </div>
        </div>

        <div className="p-6">

          {/* Eylül odağı */}
          <div className="mb-6 p-4 rounded-xl bg-cyan-50 border border-cyan-200">
            <p className="text-xs font-semibold text-cyan-800 mb-1">Eylül odağı: bütçe sabit, mesaj değişiyor</p>
            <p className="text-[11px] text-cyan-700 leading-relaxed">
              Eylül, eğlence merkezi kategorisinin yılın en sert daraldığı ayı. Okul açılıyor, hafta sonu gezisi
              talebi düşüyor. İstanbul'da izlediğimiz 10 kelimelik sepet Ağustos'tan Eylül'e iki yıl üst üste
              yaklaşık dörtte bir küçülüyor.
              Bütçe buna rağmen Ağustos seviyesinde kalıyor: ₺289.724 harcandı, Eylül planı ₺300.000.
              Gerekçe hacim değil karma. Kategorinin tamamı düşmüyor; düşen kısım "gel gez, gel eğlen" tarafı.
              Atölye, doğum günü ve oyun alanı sorguları ya sabit kalıyor ya artıyor. Plan parayı bu üç başlığa
              kaydırıyor.
              Ay toplamı sabit ama içindeki dağılım ciddi biçimde değişiyor. Meta ₺196.237'den ₺145.000'e iniyor,
              Google Arama ₺51.147'den ₺105.000'e çıkıyor. Aramanın içinde en çok büyüyen kalem jenerik kampanya:
              ₺13.667'den ₺60.000'e. Sebebi basit, Eylül'de büyüyen segmentler (atölye, doğum günü, oyun alanı)
              insanların Instagram'da denk geldiği değil, Google'da aradığı şeyler.
              Meta tarafında da bir ayrım yapılıyor: geniş erişim bugüne kadar etkileşim hedefiyle satın alınıyordu,
              artık ayrı bir farkındalık kampanyası açılıyor. Aynı erişim orada kat kat ucuza geliyor.
              Kapanan tek kalem Google Display: ₺10.088 harcadı, 49.510 tıklama getirdi, sıfır dönüşüm üretti.
            </p>
          </div>

          {/* Arama talebi */}
          <div className="mb-6 rounded-xl border border-slate-200 overflow-hidden">
            <div className="bg-slate-100 px-4 py-2.5 text-xs font-semibold text-gray-800">
              İstanbul'da kategori araması Eylül'de daralıyor, ama her segment değil
            </div>

            <div className="grid grid-cols-2 lg:grid-cols-4 gap-3 p-4">
              <div className="rounded-lg border border-rose-100 bg-rose-50 p-3">
                <p className="text-[10px] font-medium text-rose-700">Eylül 2025, Ağustos'a göre</p>
                <p className="text-lg font-bold text-rose-800 mt-0.5">-%26</p>
                <p className="text-[10px] text-rose-600">64.760 → 48.110 arama/ay</p>
              </div>
              <div className="rounded-lg border border-rose-100 bg-rose-50 p-3">
                <p className="text-[10px] font-medium text-rose-700">Eylül 2024, Ağustos'a göre</p>
                <p className="text-lg font-bold text-rose-800 mt-0.5">-%27</p>
                <p className="text-[10px] text-rose-600">47.610 → 34.530 arama/ay</p>
              </div>
              <div className="rounded-lg border border-emerald-100 bg-emerald-50 p-3">
                <p className="text-[10px] font-medium text-emerald-700">Atölye talebi, yıllık</p>
                <p className="text-lg font-bold text-emerald-800 mt-0.5">2,9 kat</p>
                <p className="text-[10px] text-emerald-600">"çocuk atölyesi" Tem 2025: 1.000 · Tem 2026: 2.900</p>
              </div>
              <div className="rounded-lg border border-slate-200 bg-slate-50 p-3">
                <p className="text-[10px] font-medium text-gray-600">Eylül'de düşmeyen segmentler</p>
                <p className="text-lg font-bold text-gray-800 mt-0.5">4 kelime</p>
                <p className="text-[10px] text-gray-500">oyun parkı · çocuk oyun alanı · doğum günü · atölye</p>
              </div>
            </div>

            <div className="overflow-x-auto">
              <table className="min-w-full text-[11px]">
                <thead className="bg-gray-50 text-gray-500">
                  <tr>
                    <th className="px-4 py-2 text-left font-medium uppercase tracking-wider">Kelime</th>
                    <th className="px-4 py-2 text-right font-medium uppercase tracking-wider">Ağu 2025</th>
                    <th className="px-4 py-2 text-right font-medium uppercase tracking-wider">Eyl 2025</th>
                    <th className="px-4 py-2 text-right font-medium uppercase tracking-wider">Değişim</th>
                    <th className="px-4 py-2 text-right font-medium uppercase tracking-wider">Ağu 2024</th>
                    <th className="px-4 py-2 text-right font-medium uppercase tracking-wider">Eyl 2024</th>
                    <th className="px-4 py-2 text-right font-medium uppercase tracking-wider">Değişim</th>
                  </tr>
                </thead>
                <tbody className="bg-white divide-y divide-gray-100 text-gray-700">
                  <tr>
                    <td className="px-4 py-2 font-medium">hupalupa <span className="text-[10px] text-gray-400">marka</span></td>
                    <td className="px-4 py-2 text-right">40.500</td>
                    <td className="px-4 py-2 text-right">27.100</td>
                    <td className="px-4 py-2 text-right font-semibold text-rose-600">-%33</td>
                    <td className="px-4 py-2 text-right">22.200</td>
                    <td className="px-4 py-2 text-right">14.800</td>
                    <td className="px-4 py-2 text-right text-rose-600">-%33</td>
                  </tr>
                  <tr>
                    <td className="px-4 py-2 font-medium">eğlence merkezi</td>
                    <td className="px-4 py-2 text-right">12.100</td>
                    <td className="px-4 py-2 text-right">9.900</td>
                    <td className="px-4 py-2 text-right font-semibold text-rose-600">-%18</td>
                    <td className="px-4 py-2 text-right">12.100</td>
                    <td className="px-4 py-2 text-right">8.100</td>
                    <td className="px-4 py-2 text-right font-semibold text-rose-600">-%33</td>
                  </tr>
                  <tr>
                    <td className="px-4 py-2 font-medium">çocuklarla gezilecek yerler</td>
                    <td className="px-4 py-2 text-right">1.900</td>
                    <td className="px-4 py-2 text-right">1.000</td>
                    <td className="px-4 py-2 text-right font-semibold text-rose-600">-%47</td>
                    <td className="px-4 py-2 text-right">2.400</td>
                    <td className="px-4 py-2 text-right">1.300</td>
                    <td className="px-4 py-2 text-right font-semibold text-rose-600">-%46</td>
                  </tr>
                  <tr>
                    <td className="px-4 py-2 font-medium">trambolin park</td>
                    <td className="px-4 py-2 text-right">1.300</td>
                    <td className="px-4 py-2 text-right">880</td>
                    <td className="px-4 py-2 text-right text-rose-600">-%32</td>
                    <td className="px-4 py-2 text-right">1.300</td>
                    <td className="px-4 py-2 text-right">1.300</td>
                    <td className="px-4 py-2 text-right text-gray-400">%0</td>
                  </tr>
                  <tr className="bg-emerald-50/50">
                    <td className="px-4 py-2 font-semibold">çocuk atölyesi</td>
                    <td className="px-4 py-2 text-right">1.000</td>
                    <td className="px-4 py-2 text-right">1.300</td>
                    <td className="px-4 py-2 text-right font-semibold text-emerald-600">+%30</td>
                    <td className="px-4 py-2 text-right">720</td>
                    <td className="px-4 py-2 text-right">590</td>
                    <td className="px-4 py-2 text-right text-rose-600">-%18</td>
                  </tr>
                  <tr className="bg-emerald-50/50">
                    <td className="px-4 py-2 font-semibold">çocuk doğum günü</td>
                    <td className="px-4 py-2 text-right">170</td>
                    <td className="px-4 py-2 text-right">210</td>
                    <td className="px-4 py-2 text-right font-semibold text-emerald-600">+%24</td>
                    <td className="px-4 py-2 text-right">210</td>
                    <td className="px-4 py-2 text-right">260</td>
                    <td className="px-4 py-2 text-right font-semibold text-emerald-600">+%24</td>
                  </tr>
                  <tr>
                    <td className="px-4 py-2 font-medium">doğum günü organizasyonu</td>
                    <td className="px-4 py-2 text-right">1.600</td>
                    <td className="px-4 py-2 text-right">1.600</td>
                    <td className="px-4 py-2 text-right text-gray-400">%0</td>
                    <td className="px-4 py-2 text-right">2.900</td>
                    <td className="px-4 py-2 text-right">2.400</td>
                    <td className="px-4 py-2 text-right text-rose-600">-%17</td>
                  </tr>
                  <tr>
                    <td className="px-4 py-2 font-medium">oyun parkı</td>
                    <td className="px-4 py-2 text-right">2.900</td>
                    <td className="px-4 py-2 text-right">2.900</td>
                    <td className="px-4 py-2 text-right text-gray-400">%0</td>
                    <td className="px-4 py-2 text-right">2.900</td>
                    <td className="px-4 py-2 text-right">2.900</td>
                    <td className="px-4 py-2 text-right text-gray-400">%0</td>
                  </tr>
                  <tr>
                    <td className="px-4 py-2 font-medium">çocuk oyun alanı</td>
                    <td className="px-4 py-2 text-right">2.900</td>
                    <td className="px-4 py-2 text-right">2.900</td>
                    <td className="px-4 py-2 text-right text-gray-400">%0</td>
                    <td className="px-4 py-2 text-right">2.400</td>
                    <td className="px-4 py-2 text-right">2.400</td>
                    <td className="px-4 py-2 text-right text-gray-400">%0</td>
                  </tr>
                  <tr className="bg-gray-50 font-semibold text-gray-800">
                    <td className="px-4 py-2">Sepet toplamı (10 kelime)</td>
                    <td className="px-4 py-2 text-right">64.760</td>
                    <td className="px-4 py-2 text-right">48.110</td>
                    <td className="px-4 py-2 text-right text-rose-600">-%26</td>
                    <td className="px-4 py-2 text-right">47.610</td>
                    <td className="px-4 py-2 text-right">34.530</td>
                    <td className="px-4 py-2 text-right text-rose-600">-%27</td>
                  </tr>
                </tbody>
              </table>
            </div>

            <div className="px-4 py-2.5 bg-slate-50 border-t border-slate-200 text-[11px] text-gray-700 leading-relaxed">
              Düşüşün tamamı gezi ve ziyaret niyetli sorgularda. Planlı etkinlik tarafı, yani atölye ve doğum günü,
              ya sabit kalıyor ya artıyor. Eylül'de aynı parayla aynı sonucu almanın yolu bu iki başlığa geçmek.
              Ayrıca "çocuk atölyesi" sorgusu mevsimden bağımsız olarak yıllık bazda büyüyor: Temmuz 2025'te
              1.000, Temmuz 2026'da 2.900. Kategori küçülürken bu segment üç katına çıkmış durumda.
              Marka araması "hupalupa" da Eylül'de düşen taraftadır, bu yüzden marka kampanyasının bütçesi
              Ağustos'un üzerine çıkarılmıyor.
              Sepet 10 kelimeden oluşuyor. Kaynak Google Ads Keyword Planner, İstanbul, Türkçe,
              yalnızca Google Arama (Arama Ortakları hariç).
            </div>
          </div>

          {/* Ön koşul */}
          <div className="mb-6 rounded-xl border-2 border-rose-300 bg-rose-50 p-4">
            <p className="text-xs font-semibold text-rose-900 mb-1">Planın iki ön koşulu</p>
            <p className="text-[11px] text-rose-800 leading-relaxed">
              <strong>Display kapatılıyor.</strong> Display kampanyası Ağustos'ta ₺10.088 harcadı ve 512.522 gösterimde
              49.510 tıklama getirdi. Bu, Display için yüzde 9,66 tıklama oranı demek; gerçek ilgiden değil,
              yanlışlıkla dokunulan yerleşimlerden gelen bir sayı. Dönüşüm sıfır. Bütçesi Eylül'de sıfırlanıyor,
              yeniden açılması ancak yerleşim listesi temizlenirse gündeme gelir.
              <br />
              <strong>Jenerik aramada kelime listesi.</strong> Jenerik kampanya ₺13.667'den ₺60.000'e çıkıyor,
              yani 4,4 katına. Ağustos'taki performansı bu artışı kendiliğinden hak etmiyor: 4.979 tıklama geldi,
              yalnızca 12,6 dönüşüm sayıldı. Tıklama başı maliyet ₺2,74 ile çok ucuz, ki bu iyi haber gibi durup
              aslında kötü haber: bu kadar ucuz tıklama, geniş eşlemeyle alakasız sorgulara girildiğini gösterir.
              Bütçe serbest bırakılmadan önce kelime listesi Eylül'de büyüyen üç segmente daraltılmalı
              (atölye, doğum günü, oyun alanı), eşleme tipi sıkılaştırılmalı ve arama terimleri raporundan
              negatif liste çıkarılmalı. Bu yapılmazsa kampanya ₺25.000'de tutulur, kalan ₺35.000 marka ve
              rakip kampanyalarına bölünür.
              <br />
              <strong>Rezervasyon ölçümü.</strong> Bu markada tek ölçülebilir sonuç Instagram üzerinden başlayan
              mesaj: Ağustos'ta 719 adet. Mesajın kaçının rezervasyona döndüğü hesapta görünmüyor.
              Bu kayıt tutulmadığı için mesaj bütçesi bu ay ₺95.000'den ₺55.000'e çekiliyor; para ölçülebilir
              olan aramaya gidiyor. Kayıt tutulmaya başlarsa Ekim'de mesaj tarafı yeniden büyütülür.
            </p>
          </div>

          {/* Ağustos gerçekleşen → Eylül plan */}
          <div className="mb-6 rounded-xl border border-slate-200 overflow-hidden">
            <div className="bg-slate-100 px-4 py-2.5 text-xs font-semibold text-gray-800">Ağustos 2026 gerçekleşen ve Eylül 2026 planı</div>
            <div className="overflow-x-auto">
              <table className="min-w-full text-[11px]">
                <thead className="bg-gray-50 text-gray-500">
                  <tr>
                    <th className="px-4 py-2 text-left font-medium uppercase tracking-wider">Mecra</th>
                    <th className="px-4 py-2 text-right font-medium uppercase tracking-wider">Ağustos harcama</th>
                    <th className="px-4 py-2 text-right font-medium uppercase tracking-wider">Ağustos birim maliyet</th>
                    <th className="px-4 py-2 text-left font-medium uppercase tracking-wider">Ağustos sonucu</th>
                    <th className="px-4 py-2 text-right font-medium uppercase tracking-wider">Eylül planı</th>
                    <th className="px-4 py-2 text-right font-medium uppercase tracking-wider">Değişim</th>
                  </tr>
                </thead>
                <tbody className="bg-white divide-y divide-gray-100 text-gray-700">
                  <tr>
                    <td className="px-4 py-2 font-medium">Meta Ads</td>
                    <td className="px-4 py-2 text-right">₺196.237</td>
                    <td className="px-4 py-2 text-right">₺59,6 CPM · ₺7,46 CPC</td>
                    <td className="px-4 py-2">1,70M erişim · 719 mesaj · 5.234 etkileşim</td>
                    <td className="px-4 py-2 text-right font-semibold">₺145.000</td>
                    <td className="px-4 py-2 text-right text-rose-600">-%26</td>
                  </tr>
                  <tr>
                    <td className="px-4 py-2 font-medium">Google Arama</td>
                    <td className="px-4 py-2 text-right">₺51.147</td>
                    <td className="px-4 py-2 text-right">₺3,30 CPC</td>
                    <td className="px-4 py-2">15.507 tık · 872 dönüşüm (marka ağırlıklı)</td>
                    <td className="px-4 py-2 text-right font-semibold">₺105.000</td>
                    <td className="px-4 py-2 text-right text-emerald-600">+%105</td>
                  </tr>
                  <tr>
                    <td className="px-4 py-2 font-medium">YouTube</td>
                    <td className="px-4 py-2 text-right">₺10.641</td>
                    <td className="px-4 py-2 text-right">₺22,58 CPM</td>
                    <td className="px-4 py-2">471.195 gösterim</td>
                    <td className="px-4 py-2 text-right font-semibold">₺30.000</td>
                    <td className="px-4 py-2 text-right text-emerald-600">+%182</td>
                  </tr>
                  <tr>
                    <td className="px-4 py-2 font-medium">TikTok Ads</td>
                    <td className="px-4 py-2 text-right">₺21.611</td>
                    <td className="px-4 py-2 text-right">₺28,82 CPM</td>
                    <td className="px-4 py-2">749.846 gösterim · 625.062 video oynatma</td>
                    <td className="px-4 py-2 text-right font-semibold">₺20.000</td>
                    <td className="px-4 py-2 text-right text-rose-600">-%7</td>
                  </tr>
                  <tr>
                    <td className="px-4 py-2 font-medium text-gray-500">Google Display</td>
                    <td className="px-4 py-2 text-right">₺10.088</td>
                    <td className="px-4 py-2 text-right text-gray-400">-</td>
                    <td className="px-4 py-2 text-rose-600">49.510 tık (CTR %9,66) · sıfır dönüşüm</td>
                    <td className="px-4 py-2 text-right font-semibold text-gray-400">₺0</td>
                    <td className="px-4 py-2 text-right text-rose-600">kapatıldı</td>
                  </tr>
                  <tr className="bg-gray-50 font-semibold text-gray-800">
                    <td className="px-4 py-2">Toplam</td>
                    <td className="px-4 py-2 text-right">₺289.724</td>
                    <td className="px-4 py-2 text-right">-</td>
                    <td className="px-4 py-2">719 mesaj</td>
                    <td className="px-4 py-2 text-right">₺300.000</td>
                    <td className="px-4 py-2 text-right text-emerald-600">+%4</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div className="px-4 py-2.5 bg-slate-50 border-t border-slate-200 text-[11px] text-gray-700">
              Ay toplamı pratikte sabit, içindeki dağılım ciddi biçimde değişiyor. Meta dörtte bir küçülüyor,
              arama iki katına çıkıyor. Kaynak üç yerden geliyor: kapanan Display ₺10.088, mesaj kampanyalarından
              alınan ₺40.000, ve etkileşim kampanyasından alınan pay.
              Gerekçe, Eylül'de büyüyen segmentlerin nerede aranıp bulunduğu. Atölye, doğum günü ve oyun alanı
              insanların akışta denk geldiği değil, ihtiyaç duyduğunda Google'da yazdığı şeyler.
              Kategorinin daraldığı bir ayda geniş erişim satın almanın getirisi düşer; niyeti belli olan aramada
              ise kişi başı maliyet değişmez.
            </div>
          </div>

          {/* Amaç bazlı dağılım */}
          <div className="rounded-xl border overflow-hidden mb-6">
            <div className="bg-slate-100 px-4 py-3 font-semibold text-gray-800">Kampanya amacına göre bütçe dağılımı</div>
            <div className="px-4 pt-4">
              <div className="flex w-full h-3 rounded-full overflow-hidden border border-gray-200">
                <div className="bg-emerald-400" style={{ width: '53.3%' }} title="Dönüşüm %53" />
                <div className="bg-red-400" style={{ width: '25.0%' }} title="Farkındalık %25" />
                <div className="bg-pink-400" style={{ width: '21.7%' }} title="Etkileşim %22" />
              </div>
            </div>
            <div className="overflow-x-auto">
              <table className="min-w-full text-[12px] mt-3">
                <thead className="bg-gray-50 text-gray-500">
                  <tr>
                    <th className="px-4 py-2 text-left font-medium uppercase tracking-wider text-[11px]">Amaç</th>
                    <th className="px-4 py-2 text-right font-medium uppercase tracking-wider text-[11px]">Bütçe</th>
                    <th className="px-4 py-2 text-right font-medium uppercase tracking-wider text-[11px]">Pay</th>
                    <th className="px-4 py-2 text-left font-medium uppercase tracking-wider text-[11px]">Kampanyalar</th>
                  </tr>
                </thead>
                <tbody className="bg-white divide-y divide-gray-100 text-gray-700">
                  <tr>
                    <td className="px-4 py-2.5"><Amac tip="Dönüşüm" not="mesaj ve arama" /></td>
                    <td className="px-4 py-2.5 text-right font-semibold">₺160.000</td>
                    <td className="px-4 py-2.5 text-right">%53,3</td>
                    <td className="px-4 py-2.5">Google Arama 3 kampanya (₺105.000) · Meta 2 mesaj kampanyası (₺55.000)</td>
                  </tr>
                  <tr>
                    <td className="px-4 py-2.5"><Amac tip="Farkındalık" /></td>
                    <td className="px-4 py-2.5 text-right font-semibold">₺75.000</td>
                    <td className="px-4 py-2.5 text-right">%25,0</td>
                    <td className="px-4 py-2.5">YouTube erişim (₺30.000) · Meta farkındalık (₺25.000) · TikTok video (₺20.000)</td>
                  </tr>
                  <tr>
                    <td className="px-4 py-2.5"><Amac tip="Etkileşim" /></td>
                    <td className="px-4 py-2.5 text-right font-semibold">₺65.000</td>
                    <td className="px-4 py-2.5 text-right">%21,7</td>
                    <td className="px-4 py-2.5">Meta etkileşim</td>
                  </tr>
                  <tr className="bg-gray-50 font-semibold text-gray-800">
                    <td className="px-4 py-2.5">Toplam</td>
                    <td className="px-4 py-2.5 text-right">₺300.000</td>
                    <td className="px-4 py-2.5 text-right">%100</td>
                    <td className="px-4 py-2.5">4 mecra · 9 kampanya</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div className="px-4 py-2.5 bg-emerald-50 border-t border-emerald-100 text-[11px] text-emerald-800">
              Ağustos'ta ölçülebilir sonuç hedefleyen kalemlerin payı %42'ydi (mesaj %25 + arama %18), Eylül'de %53.
              Etkileşimin payı ise %43'ten %22'ye iniyor.
              Farkındalık %17'den %25'e çıkarken maliyeti düşüyor: bu erişim artık etkileşim hedefiyle değil,
              kendi kampanyasıyla ve kat kat ucuza satın alınıyor.
            </div>
          </div>

          {/* Bütçe kartları */}
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 mb-6">
            <div className="rounded-xl border border-indigo-100 bg-indigo-50 p-4">
              <div className="flex items-center gap-2 mb-1">
                <img src="/6033716.png" alt="Meta" className="w-5 h-5 object-contain" />
                <span className="text-xs font-medium text-indigo-700">Meta Ads</span>
              </div>
              <p className="text-xl font-bold text-indigo-800">₺145.000</p>
              <p className="text-[10px] text-indigo-600 mt-0.5">%48 · etkileşim + farkındalık + 2 mesaj</p>
            </div>
            <div className="rounded-xl border border-blue-100 bg-blue-50 p-4">
              <div className="flex items-center gap-2 mb-1">
                <img src="/google_ads-512.webp" alt="Google" className="w-5 h-5 object-contain" />
                <span className="text-xs font-medium text-blue-700">Google Ads</span>
              </div>
              <p className="text-xl font-bold text-blue-800">₺135.000</p>
              <p className="text-[10px] text-blue-600 mt-0.5">%45 · Arama ₺105.000 + YouTube ₺30.000</p>
            </div>
            <div className="rounded-xl border border-gray-200 bg-gray-50 p-4">
              <div className="flex items-center gap-2 mb-1">
                <img src="/tiktokv4.svg" alt="TikTok" className="w-5 h-5 object-contain" />
                <span className="text-xs font-medium text-gray-700">TikTok Ads</span>
              </div>
              <p className="text-xl font-bold text-gray-800">₺20.000</p>
              <p className="text-[10px] text-gray-600 mt-0.5">%7 · video izlenme</p>
            </div>
          </div>

          {/* ANA PLAN TABLOSU */}
          <div className="rounded-xl border overflow-hidden mb-8">
            <div className="bg-slate-100 px-4 py-3 font-semibold text-gray-800">Medya Planı, HUPALUPA Eğlence Eylül 2026</div>
            <div className="overflow-x-auto">
              <table className="min-w-full divide-y divide-gray-200">
                <thead className="bg-gray-50">
                  <tr>
                    <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Mecra</th>
                    <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Kampanya</th>
                    <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Hedef kitle</th>
                    <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Amaç</th>
                    <th className="px-4 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider">Bütçe</th>
                  </tr>
                </thead>
                <tbody className="bg-white divide-y divide-gray-100 text-[12px] text-gray-700">

                  {/* Meta */}
                  <tr className="hover:bg-gray-50">
                    <td className="px-4 py-3 font-medium align-top" rowSpan={4}>
                      <div className="flex items-center gap-2">
                        <img src="/6033716.png" alt="Meta" className="w-5 h-5 object-contain" />
                        <span>Meta Ads</span>
                      </div>
                    </td>
                    <td className="px-4 py-3">Etkileşim</td>
                    <td className="px-4 py-3">İstanbul geneli, 25-45 yaş ebeveyn</td>
                    <td className="px-4 py-3"><Amac tip="Etkileşim" /></td>
                    <td className="px-4 py-3 text-right font-medium">₺65.000</td>
                  </tr>
                  <tr className="hover:bg-gray-50">
                    <td className="px-4 py-3">Farkındalık, geniş erişim <span className="text-[10px] text-blue-600 font-medium">yeni</span></td>
                    <td className="px-4 py-3">İstanbul geneli, ebeveyn demografisi</td>
                    <td className="px-4 py-3"><Amac tip="Farkındalık" /></td>
                    <td className="px-4 py-3 text-right font-medium">₺25.000</td>
                  </tr>
                  <tr className="hover:bg-gray-50">
                    <td className="px-4 py-3">Mesaj, <strong>atölye</strong></td>
                    <td className="px-4 py-3">Ataşehir ve çevre ilçeler, okul çağı çocuk ebeveyni</td>
                    <td className="px-4 py-3"><Amac tip="Dönüşüm" not="mesaj" /></td>
                    <td className="px-4 py-3 text-right font-medium">₺33.000</td>
                  </tr>
                  <tr className="hover:bg-gray-50">
                    <td className="px-4 py-3">Mesaj, <strong>doğum günü</strong> <span className="text-[10px] text-blue-600 font-medium">yeni</span></td>
                    <td className="px-4 py-3">Yakın çevre ve sayfa etkileşimcileri, doğum günü ve organizasyon ilgisi</td>
                    <td className="px-4 py-3"><Amac tip="Dönüşüm" not="mesaj" /></td>
                    <td className="px-4 py-3 text-right font-medium">₺22.000</td>
                  </tr>
                  <tr className="bg-indigo-50 font-semibold text-indigo-800">
                    <td className="px-4 py-3" colSpan={4}>Meta Ads toplam</td>
                    <td className="px-4 py-3 text-right">₺145.000</td>
                  </tr>

                  {/* Google */}
                  <tr className="hover:bg-gray-50">
                    <td className="px-4 py-3 font-medium align-top" rowSpan={4}>
                      <div className="flex items-center gap-2">
                        <img src="/google_ads-512.webp" alt="Google Ads" className="w-5 h-5 object-contain" />
                        <span>Google Ads</span>
                      </div>
                    </td>
                    <td className="px-4 py-3">Arama, <strong>kategori kelimeleri</strong></td>
                    <td className="px-4 py-3">çocuk atölyesi, doğum günü organizasyonu, oyun parkı, çocuk oyun alanı</td>
                    <td className="px-4 py-3"><Amac tip="Dönüşüm" /></td>
                    <td className="px-4 py-3 text-right font-medium">₺60.000</td>
                  </tr>
                  <tr className="hover:bg-gray-50">
                    <td className="px-4 py-3">Arama, marka kelimeleri</td>
                    <td className="px-4 py-3">hupalupa, hupalupa ataşehir, hupalupa bilet</td>
                    <td className="px-4 py-3"><Amac tip="Dönüşüm" /></td>
                    <td className="px-4 py-3 text-right font-medium">₺40.000</td>
                  </tr>
                  <tr className="hover:bg-gray-50">
                    <td className="px-4 py-3">Arama, rakip markalar</td>
                    <td className="px-4 py-3">Çevredeki eğlence merkezi marka adları</td>
                    <td className="px-4 py-3"><Amac tip="Dönüşüm" /></td>
                    <td className="px-4 py-3 text-right font-medium">₺5.000</td>
                  </tr>
                  <tr className="hover:bg-gray-50">
                    <td className="px-4 py-3">YouTube, erişim</td>
                    <td className="px-4 py-3">İstanbul, ebeveyn ve çocuk içeriği izleyicileri</td>
                    <td className="px-4 py-3"><Amac tip="Farkındalık" /></td>
                    <td className="px-4 py-3 text-right font-medium">₺30.000</td>
                  </tr>
                  <tr className="bg-blue-50 font-semibold text-blue-800">
                    <td className="px-4 py-3" colSpan={4}>Google Ads toplam</td>
                    <td className="px-4 py-3 text-right">₺135.000</td>
                  </tr>

                  {/* TikTok */}
                  <tr className="hover:bg-gray-50">
                    <td className="px-4 py-3 font-medium align-top">
                      <div className="flex items-center gap-2">
                        <img src="/tiktokv4.svg" alt="TikTok" className="w-5 h-5 object-contain" />
                        <span>TikTok Ads</span>
                      </div>
                    </td>
                    <td className="px-4 py-3">Video izlenme</td>
                    <td className="px-4 py-3">İstanbul, 25-45 yaş, aile ve çocuk içeriği izleyicileri</td>
                    <td className="px-4 py-3"><Amac tip="Farkındalık" /></td>
                    <td className="px-4 py-3 text-right font-medium">₺20.000</td>
                  </tr>
                  <tr className="bg-gray-100 font-semibold text-gray-800">
                    <td className="px-4 py-3" colSpan={4}>TikTok Ads toplam</td>
                    <td className="px-4 py-3 text-right">₺20.000</td>
                  </tr>

                  {/* Kapatilan */}
                  <tr className="bg-rose-50/60 text-gray-500">
                    <td className="px-4 py-3 font-medium">Google Display</td>
                    <td className="px-4 py-3">Display, geniş erişim</td>
                    <td className="px-4 py-3" colSpan={2}>Ağustos'ta ₺10.088 harcadı, CTR %9,66, sıfır dönüşüm. Eylül'de açılmıyor.</td>
                    <td className="px-4 py-3 text-right font-medium">₺0</td>
                  </tr>

                  <tr className="bg-gray-800 text-white font-bold">
                    <td className="px-4 py-3" colSpan={4}>GENEL TOPLAM</td>
                    <td className="px-4 py-3 text-right">₺300.000</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          {/* Plan ↔ gerçekleşen; mecralardan canlı okunur (bkz. EylulGerceklesen). */}
          <EylulGerceklesen
            brandId={BRAND_ID}
            plan={MECRA_PLANI}
            kpi="conversation"
            notlar="TikTok hesabı Store ile ortak; buradaki tutar kampanya adına göre süzülmüş Eğlence payıdır, Store ve NeeDoh kampanyaları düşülmüştür."
          />

          {/* Uygulama notları */}
          <div className="rounded-xl border overflow-hidden mb-8">
            <div className="bg-slate-100 px-4 py-3 font-semibold text-gray-800">Uygulama notları</div>
            <div className="p-5 grid grid-cols-1 md:grid-cols-2 gap-5 text-[12px] text-gray-700">
              <div>
                <p className="font-semibold text-gray-800 mb-1">Doğum günü ayrı kampanyaya çıkıyor</p>
                <p className="leading-relaxed">
                  Ağustos'ta doğum günü mesajı atölye kampanyasının içindeydi, kendi bütçesi ve kendi ölçümü yoktu.
                  Eylül'de ayrılıyor. Sebebi mevsim: atölye ve doğum günü aynı takvimde değil.
                  "çocuk doğum günü" sorgusu Eylül'de iki yıl da yüzde 24 artıyor, "doğum günü organizasyonu"
                  ise düşmüyor. Ayrı kampanya, bu talebin karşılığının ay sonunda görülebilmesi için gerekli.
                </p>
              </div>
              <div>
                <p className="font-semibold text-gray-800 mb-1">Erişim artık etkileşim hedefiyle satın alınmıyor</p>
                <p className="leading-relaxed">
                  Bugüne kadar geniş erişimin tamamı etkileşim hedefli kampanyadan geliyordu. O kampanyanın
                  bin gösterim maliyeti Ağustos'ta ₺43,9'du. Aynı hesapta Temmuz'da farkındalık hedefiyle çalışan
                  bir carousel kampanyası vardı ve onun bin gösterim maliyeti ₺7,45'ti, yani yaklaşık altıda biri.
                  Etkileşim hedefi insanları yorum ve beğeni yapmaya zorladığı için gösterimi pahalıya alır;
                  amaç sadece görünmekse yanlış hedef.
                  Eylül'de ikisi ayrılıyor: etkileşim ₺65.000'e iniyor, yanına ₺25.000'lik ayrı bir farkındalık
                  kampanyası açılıyor. Toplam erişim artmasına rağmen para azalıyor.
                </p>
              </div>
              <div>
                <p className="font-semibold text-gray-800 mb-1">Aramada dönüşümlerin neredeyse tamamı marka</p>
                <p className="leading-relaxed">
                  Ağustos'ta Google Arama 872 dönüşüm gösteriyor ama bunun 859'u marka kampanyasından,
                  yani zaten Hupalupa'yı arayan kişiden geliyor. Jenerik kampanya 4.979 tıklamaya karşılık
                  12,6 dönüşüm üretti. Marka kampanyası markanın kendi talebini topluyor, yeni talep yaratmıyor;
                  o yüzden bütçesi Ağustos seviyesinin biraz üstünde tutuluyor, dört katına çıkarılmıyor.
                  Bütün artış kategori kampanyasına gidiyor: ₺13.667'den ₺60.000'e. Buradaki bahis şu:
                  Ağustos'ta bu kampanya ucuz ama niyetsiz trafik aldı, kelime listesi Eylül'de büyüyen üç
                  segmente daraltılırsa aynı para daha az ama daha niyetli tıklama getirir.
                  Bu yüzden ay içinde takip edilecek metrik tıklama sayısı değil, mesaj ve arama başına düşen
                  rezervasyon olacak. Tıklama artıp mesaj artmıyorsa liste hâlâ geniştir.
                </p>
              </div>
              <div>
                <p className="font-semibold text-gray-800 mb-1">TikTok'ta tıklama sayısına bakılmayacak</p>
                <p className="leading-relaxed">
                  TikTok hesabında Ağustos'ta 190.255 tıklama görünüyor ve bu sayı etkileşim sayısıyla birebir aynı.
                  Yani platform tıklama diye etkileşimi raporluyor. Bu kanalda takip edilecek metrik video oynatma
                  ve erişim; tıklama ve tıklama başı maliyet raporlanmayacak.
                  Ayrıca TikTok reklam hesabı Store ile ortak: Ağustos'ta bu markanın harcamasında görünen
                  ₺4.938'lik trafik kampanyası aslında Store'a ait. Eylül'de kampanyalar marka bazında ayrıştırılacak.
                </p>
              </div>
            </div>
          </div>

          {/* Projeksiyon notu */}
          <div className="p-4 rounded-xl bg-amber-50 border border-amber-200">
            <div className="flex items-start gap-2.5">
              <div className="flex-shrink-0 mt-0.5">
                <svg className="w-4 h-4 text-amber-500" fill="currentColor" viewBox="0 0 20 20">
                  <path fillRule="evenodd" d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
                </svg>
              </div>
              <div>
                <p className="text-xs font-semibold text-amber-800">Veri notu</p>
                <p className="text-[11px] text-amber-700 mt-1 leading-relaxed">
                  Ağustos rakamları ay kapandıktan sonra, 1 Eylül 2026'da canlı API'lerden çekildi.
                  Meta tarafı act_1492081179012995, Google tarafı müşteri 6717327296, TikTok tarafı
                  advertiser 7604848080818683921.
                  TikTok reklam hesabı Store markasıyla ortak kullanılıyor; Ağustos toplamındaki ₺4.938'lik
                  "HupalupaStore" kampanyası bu sayfada Eğlence harcamasının içinde görünüyor.
                  TikTok'un tıklama metriği etkileşim metriğiyle aynı değeri döndürdüğü için tıklama ve
                  tıklama başı maliyet hiçbir tabloda kullanılmadı.
                  Farkındalık kampanyasının bin gösterim maliyeti varsayımı, aynı hesabın Temmuz 2026'da
                  farkındalık hedefiyle çalıştırdığı carousel kampanyasının ölçülen ₺7,45 CPM değerine dayanıyor.
                  Meta'da etkileşim sayısı gerçek etkileşimdir: tepki, yorum, paylaşım ve kaydetme toplamı.
                  Platformun "post_engagement" metriği kullanılmadı, çünkü onun neredeyse tamamı üç saniyelik
                  video izlenmesinden oluşuyor.
                  Arama hacimleri Google Ads Keyword Planner'dan, İstanbul ve Türkçe kırılımıyla alındı.
                  Planner değerleri aralık ortalamasıdır, bu yüzden pek çok kelimede değişim aynı orana denk gelir.
                </p>
              </div>
            </div>
          </div>

        </div>
      </div>

    </div>
  );
}
